import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { formatDate } from "./utils";
const updateContents = (contents) => {
    for (const [key, value] of Object.entries(contents)) {
        // remove or format some content
        switch (key) {
            case "history":
                delete contents[key];
                break;
            case "last_modified_at":
            case "created_at":
                contents[key] = formatDate(value);
                break;
        }
        // make nulls show a faded 'None'
        if (!value) {
            contents[key] = _jsx("span", { className: "tooltip-value-none", children: "None" });
        }
    }
    return contents;
};
function FormatTooltip(props) {
    return (_jsx("div", { className: "tooltip-contents", children: Object.entries(updateContents(props.contents)).map(([key, value]) => (_jsxs("div", { className: "formatted-tooltip", children: [_jsxs("span", { className: "tooltip-key", children: [key, ":"] }), _jsx("span", { className: "tooltip-value", children: value })] }, key))) }));
}
export default FormatTooltip;
